import { render, staticRenderFns } from "./whitepaper.vue?vue&type=template&id=2319c88c&scoped=true&"
import script from "./whitepaper.vue?vue&type=script&lang=ts&"
export * from "./whitepaper.vue?vue&type=script&lang=ts&"
import style0 from "./whitepaper.vue?vue&type=style&index=0&id=2319c88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319c88c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
